import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ChapterService {

  constructor(private http: HttpClient) {
  }

  get(filter: any | null = null) {
    let params = new HttpParams();

    for (const key in filter) {
      if (filter[key])
        params = params.append(key, filter[key]);
    }

    return this.http.get(`${environment.apiUrl}/Chapter`, { params: params })
  }

  getById(chapterId: number) {
    return this.http.get(`${environment.apiUrl}/Chapter/GetById?Id=${chapterId}`)
  }

  add(value: any) {
    return this.http.post(`${environment.apiUrl}/InnovationChapter`, value);
  }

  copy(chapterId: any) {
    return this.http.post(`${environment.apiUrl}/InnovationChapter/copy`, { chapterId });
  }

  update(value: any) {
    return this.http.put(`${environment.apiUrl}/InnovationChapter`, value);
  }

  delete(courseId: number) {
    return this.http.delete(`${environment.apiUrl}/InnovationChapter?Id=${courseId}`);
  }
}
